import { useCallback, useState } from "react";

import { grantProjectTeamAccess } from "Api/organizations/projects/grantProjectTeamAccess.request";
import bulkOperation from "Libs/bulkOperation";

import { useInvalidateProjectTeamAccess } from "../teams.slice";

export const useAdddProjectToTeams = () => {
  const [isLoading, setIsLoading] = useState<boolean>();
  const invalidateProjectTeamAccess = useInvalidateProjectTeamAccess();
  const [error, setError] = useState<unknown>();

  const action = useCallback(
    async (...args: Parameters<typeof grantProjectTeamAccess>) => {
      setIsLoading(true);
      try {
        const response = await bulkOperation(
          args[1].map(teamId => grantProjectTeamAccess(args[0], [teamId])),
          (_, index) => ({ teamId: args[1][index].team_id }),
          (reason, index) => ({ reason, teamId: args[1][index].team_id })
        );
        if (response.fulfilled.length > 0) {
          invalidateProjectTeamAccess(args[0]);
        }
        return response;
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    },
    [invalidateProjectTeamAccess]
  );

  return [action, isLoading, error] as const;
};
